'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const css = require('./Body-style.scss');

const Body = ({ children, bodyClass, dataTn }) => (
    <div className={classnames(bodyClass || css.body)} data-tn={`${dataTn}-modal-body`}>
        {children}
    </div>
);

Body.propTypes = {
    bodyClass: PropTypes.string,
    children: PropTypes.node,
    dataTn: PropTypes.string,
};

module.exports = Body;



// WEBPACK FOOTER //
// ./assets/js/global/views/modal/Body.jsx